// is-safari.js
export function isSafariBrowser() {
  if (typeof navigator === "undefined") return false; // SSR/Node guard

  const ua = navigator.userAgent;
  const vendor = navigator.vendor || "";

  const isIOS = /iP(hone|ad|od)/.test(ua);
  const isWebKit = /AppleWebKit/.test(ua) && !/Edge|Edg|OPR|Opera/.test(ua);

  // On iOS, all browsers use WebKit, so we must exclude other brands
  const isChromeLikeOnIOS = /CriOS/.test(ua);
  const isFirefoxOnIOS = /FxiOS/.test(ua);
  const isEdgeOnIOS = /EdgiOS/.test(ua);
  const isOperaOnIOS = /OPiOS/.test(ua);

  if (isIOS) {
    return (
      isWebKit &&
      !isChromeLikeOnIOS &&
      !isFirefoxOnIOS &&
      !isEdgeOnIOS &&
      !isOperaOnIOS
    );
  }

  // Desktop Safari: has "Safari" but not Chrome/Chromium/Edge/Opera; vendor is Apple
  return (
    /Safari/.test(ua) &&
    !/Chrome|Chromium|Edg|OPR|Opera/.test(ua) &&
    /Apple/i.test(vendor)
  );
}
